import { Chip, ChipProps, SxProps, Theme } from "@mui/material";
import { FC } from "react";

interface IChipComponentProps {
  label: string;
  backgroundColor?: string;
  color?: string;
  sx?: SxProps<Theme>;
  size?: ChipProps["size"];
}

export const ChipComponent: FC<IChipComponentProps> = ({
  label,
  backgroundColor,
  color,
  sx,
  size,
}) => {
  return (
    <Chip
      label={label}
      size={size}
      sx={{
        backgroundColor: backgroundColor ?? "primary.contrastText",
        color: color ?? "grey.100",
        ...sx,
      }}
    />
  );
};
